import React from 'react'
//import {connect} from "react-redux";

/*export const getOptionText = (deliveryOption:any)=>{
    return <DeliveryOptionTextContainer deliveryOption={deliveryOption}></DeliveryOptionTextContainer>
    //return(<DeliveryOptionText defaultLanguage={defaultLanguage} deliveryOption={deliveryOption}/>)
};*/

export default class DeliveryOptionText extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
        };
    }

    getDeliveryOptionByCurrentLang(){
        if(this.props.currentLanguage === this.props.defaultLanguage || !this.props.deliveryOption.SecondaryLanguageText)
            return this.props.deliveryOption.DefaultLanguageText;
        else
            return this.props.deliveryOption.SecondaryLanguageText;
    }

    render() 
    {
        return this.getDeliveryOptionByCurrentLang();
    }
}

/*const mapStateToProps = ({globalReducer}: any) => {
    return {
        defaultLanguage: globalReducer.styles.CommonSettings.DefaultLanguage,
        currentLanguage: globalReducer.currentLanguage
    }
};

export const DeliveryOptionTextContainer = connect<any, any, any>(
    mapStateToProps,
    null
)(DeliveryOptionText);*/